import React, { useMemo } from "react";
import parse from "html-react-parser";

import { useSiteConfig } from "utility/hooks/useSiteConfig";
import { CONFIG_GROUP } from "config/siteContent";
import { normalizeQuillHtml } from "utility/functions/normalizeQuillHtml";

const Privacy = () => {
  const config = useSiteConfig(CONFIG_GROUP.TERMS);
  const richText = config.get("content");
  const richHtml = useMemo(() => normalizeQuillHtml(richText), [richText]);
  const titles = [
    {
      id: "t1",
      type: "h4",
      title: " ㄧ、服務條款",
      content:
        "歡迎您蒞臨 Skyline Film 屋頂電影院（以下簡稱「本活動」）之網站（www.skyline.film）。為確保您的權益，請詳閱以下服務條款，當您瀏覽或使用本網站，或完成購票程序，即視為已閱讀、理解並同意遵守以下條款與規定。",
    },
    {
      id: "t2",
      type: "h4",
      title: " 二、退換票政策",
      content:
        "Skyline Film 屋頂電影院為戶外限量場次之特別活動，票券售出後即保留您的座位與活動參與資格，故請理解以下退換票條款：",
    },
  ];

  const subTitles = [
    {
      id: "st1",
      parentId: "t1",
      type: "li",
      content: "購票與入場須知",
    },
    {
      id: "st2",
      parentId: "t1",
      type: "li",
      content: "活動內容與異動",
    },
    {
      id: "st3",
      parentId: "t1",
      type: "li",
      content: "智慧財產權",
    },
    {
      id: "st4",
      parentId: "t1",
      type: "li",
      content: "個資保護",
    },
    {
      id: "st5",
      parentId: "t2",
      type: "li",
      content:
        "票券一經售出，如因特殊情況需要更換場次，請來信聯繫我們，我們將視情況提供協助，但不保證一定能受理。請於購票前確認活動時間與場次是否合適。",
    },
    {
      id: "st6",
      parentId: "t2",
      type: "li",
      content:
        "活動若遇不可抗力因素（如天候、天災、疫情、政府法令限制等）而需延期或中止時，主辦單位將評估安全條件並於活動官方平台公告處理方式。如遇主辦單位取消或延期活動，將提供以下處理方式：",
    },
    {
      id: "st7",
      parentId: "t2",
      type: "li",
      content:
        "如有特殊退票申請或其他未盡事宜，請來信至官方信箱 support@rftexp.com 聯繫，我們將提供協助。",
    },
    {
      id: "st8",
      parentId: "t2",
      type: "li",
      content:
        "未滿18歲之觀眾，請由成年人陪同參加，部分場次可能含有分級影片，購票前請確認內容是否適齡，並禁止飲酒。",
    },
  ];

  const contents = [
    {
      parentId: "st1",
      type: "li",
      content:
        "本活動票券主要透過 Skyline Film 官方網站及指定售票平台販售。若您透過他人轉讓購得票券，請務必確認票券資訊完整並避免重複使用。",
    },
    {
      parentId: "st1",
      type: "li",
      content:
        "購票成功後，系統將發送電子票券至您填寫的電子郵件信箱，入場時請出示電子票券或 QR Code 驗票。",
    },
    {
      parentId: "st1",
      type: "li",
      content:
        "未滿18歲之觀眾，請由成年人陪同參加，部分場次可能含有分級影片，購票前請確認內容是否適齡，並禁止飲酒。",
    },
    {
      parentId: "st1",
      type: "li",
      content:
        "活動座位為全躺椅，入座採先來先到制，我們不提供預先劃位或保留座位。",
    },
    {
      parentId: "st1",
      type: "li",
      content: "請注意工作人員有權請觀眾調整座位以確保每位購票者都能入席。",
    },
    {
      parentId: "st1",
      type: "li",
      content: "活動現場請勿吸菸。",
    },
    {
      parentId: "st1",
      type: "li",
      content: "禁止酒後駕車。",
    },

    {
      parentId: "st2",
      type: "li",
      content:
        "活動內容、演出時間、場地配置等如有異動，本活動主辦單位保有最終調整與解釋之權利，相關公告將於官方網站及社群平台即時更新",
    },
    {
      parentId: "st2",
      type: "li",
      content:
        "若遇不可抗力因素（如天候、天災、疫情、政府法令限制等），主辦單位有權調整或取消活動。",
    },
    {
      parentId: "st3",
      type: "li",
      content:
        "本網站所有內容（包含但不限於圖文、設計、活動影像、商標與標誌等）均屬主辦單位或其授權人所有，未經授權禁止擷取、轉載或商業使用。",
    },
    {
      parentId: "st4",
      type: "li",
      content:
        "購票與使用網站過程中所蒐集之個人資料，將依照《個人資料保護法》妥善保管與使用，僅限於活動聯繫、票務處理與行銷通知用途，並不會對外公開或提供第三方。",
    },
    {
      parentId: "st6",
      type: "li",
      content: "若活動取消，購票人可選擇全額退費或保留作為未來場次使用；",
    },
    {
      parentId: "st6",
      type: "li",
      content: "若活動延期，票券將自動順延至新日期，若無法參加可申請退費。",
    },
  ];

  // 後台填了條款內容就以富文字呈現，沒填則顯示內建的預設條款
  // 版面與字級對齊下方的預設條款：外層留白相同、內文 14px、子項目圓點為白色
  if (richHtml && richHtml.trim()) {
    return (
      <div className="w-full bg-black desktop:h-[auto] desktop:px-56 mobile:px-4 tablet:px-20 pb-3 text-left text-[14px] text-SKF-G-001 [&_h4]:text-white [&_strong]:text-white [&_a]:text-SKF-Blue-001 [&_ol]:list-decimal [&_ul]:list-disc [&_ol]:pl-5 [&_ul]:pl-5 [&_li]:pl-4 [&_li_ol]:pl-0 [&_li_ul]:pl-0 [&_li_li]:pl-0 [&_ul>li]:marker:text-white">
        {parse(richHtml)}
      </div>
    );
  }

  return (
    <div className="w-full bg-black desktop:h-[auto] desktop:px-56 mobile:px-4 tablet:px-20 pb-3 text-left">
      {titles.map((item) => {
        return (
          <item.type key={item.id} className="text-white">
            {/* 標題 */}
            {item.title}
            {/* 歡迎文字 */}
            <p key={item.id} className="text-[14px] text-SKF-G-001">
              {item.content}
            </p>

            <item.type key={item.id} className="text-SKF-G-001 text-[14px]">
              {/* 子標題 */}
              <ol className="px-5">
                {subTitles.map((subItem) => {
                  if (subItem.parentId !== item.id) return null;
                  return (
                    <subItem.type
                      key={subItem.id}
                      className="text-SKF-G-001 pl-4"
                    >
                      {subItem.content}

                      {/* 內容 */}
                      <ul className="mb-1 text-SKF-G-001 list-none relative">
                        {contents.map((innerItem) => {
                          if (innerItem.parentId !== subItem.id) return null;
                          return (
                            <innerItem.type
                              key={innerItem.id}
                              className="text-SKF-G-001 relative before:content-[''] before:absolute before:left-[-10px] before:top-3 before:w-1 before:h-1 before:bg-white before:rounded-full"
                            >
                              {innerItem.content}
                            </innerItem.type>
                          );
                        })}
                      </ul>
                    </subItem.type>
                  );
                })}
              </ol>
            </item.type>
          </item.type>
        );
      })}
    </div>
  );
};

export default Privacy;
